import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getTypeProcessActionAsync } from '../redux/actions/typeProcessActions'

export const useTypeProcess = () => {
  const { typeProcessState } = useSelector(
    (state: RootState) => state.typeProcess
  )
  const dispatch = useDispatch()

  const getTypeProcess = () => {
    dispatch(getTypeProcessActionAsync())
  }

  return { typeProcessState, getTypeProcess }
}
